<ion-app>
    <ion-router-outlet id="content" />
</ion-app>
